// extracted by mini-css-extract-plugin
module.exports = {"title":"b2b-otp_title__s6nsk","sub-title":"b2b-otp_sub-title__AayMv","input":"b2b-otp_input___X88I","info":"b2b-otp_info__ovZPL","footer":"b2b-otp_footer__eLX_M"};